<template>
  <input type='file' ref="fileUpload" class='filebutton' accept=".png, .jpg, .jpeg, .gif" :multiple="canMultiple" style='display:none' @change="fileSelected"/>
</template>

<script lang="ts">
import axios from 'axios'
import { generateRefId } from '@/utils/strings'
export default {
  name: 'LocalFileUploader',
  components: {

  },
  props: {
    useCustomUpload: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      uploadFile: null,
      canMultiple: false,
    }
  },
  methods: {
    openFile(canMultiple) {
      this.$refs.fileUpload.value = "";
      this.canMultiple = !!canMultiple
      this.$nextTick(()=>{
        this.$refs.fileUpload.click()
      })
    },
    fileSelected() {
      const that = this
      const fileList = this.$refs.fileUpload.files
      if (!fileList || fileList.length === 0) return

      for(let i=0; i< fileList.length; i++) {
        that.fileLoad(fileList[i])
      }

      // 需要清空选择的文件，当选择相同文件的时候才会触发change事件
      // this.$refs.fileUpload.value = "";
    },
    fileLoad(file) {
      const that = this
      //读取文件
      const reader = new FileReader();

      reader.onload = function(e) {
        that.startFileUpload(file, e.target.result);
      }
      this.uploadFile = file;
      reader.readAsDataURL(this.uploadFile);
    },
    addResource(uploadData, getData) {
      const _data = {
        file_name: getData.original_filename,
        ref_id: getData.rid,
        url: getData.url,
        width: uploadData.width,
        height: uploadData.height,
        length: getData.length,
        content_type: getData.mime,
      }
      this.$emit('addResource', _data)
    },
    startFileUpload(file, uploadFileResult) {
      const that = this
      const image = new Image()
      image.src = uploadFileResult
      image.onload = function () {
        const fileWidth = image.width.toString()
        const fileHeight = image.height.toString()
        if (that.useCustomUpload) {
          const _fileData = {
            file: file,
            width: fileWidth,
            height: fileHeight,
            file_name: file.name,
            length: file.size,
            identifyType: 'custom',
            local_url: image.src,
          }
          that.$emit('addResource', _fileData)
          return
        }
        const formData = new FormData()
        formData.append('type', 0)
        formData.append('file', file)
        formData.append('width', fileWidth)
        formData.append('height', fileHeight)
        formData.append('ref_id', generateRefId())
        axios({
          method: 'post',
          url: `/myani/saveimage`,
          data: formData
        }).then((response) => {
          if (response.data.status === 0) {
              that.addResource({width: fileWidth, height: fileHeight}, response.data);
          } else {
              alert(response.data.error)
          }
        }).catch((error) => {
          alert(error)
        })
      }
    },
  }
}
</script>
